<div class="main-interface" style="flex-direction: column;" data-cy="scheduler-main-container">
  <div class="scheduler-header" data-cy="scheduler-header-section">
    <app-scheduler-view-options style="flex-basis: 250px;"
                                (viewTypeChange)="onViewTypeChange($event)"
                                data-cy="scheduler-view-options"></app-scheduler-view-options>
    <div style="flex-basis: 1px; background-color: var(--tdo-primary); opacity: 0.2;"></div>
    <div style="flex-basis: 320px;" data-cy="scheduler-calendar-section">
      <app-tdo-mini-calendar #calendar [isGetAppointmentDays]="true"
                             (selectedDateChange)="onSelectedDateChange($event)"
                             data-cy="scheduler-mini-calendar"></app-tdo-mini-calendar>
    </div>
    <!--<div style="flex-basis: 640px;" *ngIf="viewType === 'dayDetailView'">
    </div>-->
    <div style="flex-basis: 1px; background-color: var(--tdo-primary); opacity: 0.2;"></div>
    <div style="flex-basis: 500px; flex-grow: 1;" data-cy="scheduler-operatory-section">
      <app-scheduler-operatory-selector *ngIf="viewType !== 'dayDetailView'"
                                        (operatoriesSelected)="onOperatoriesSelected($event)"
                                        (locationsOpsChanged)="onLocationsOrOpsChanged($event)"
                                        (locationsSelected)="onLocationsSelected($event)"
                                        data-cy="scheduler-operatory-selector">
      </app-scheduler-operatory-selector>
      <div *ngIf="viewType == 'dayDetailView'" style="width: 100%; height: 100%; padding: 6px;" data-cy="scheduler-doctor-selector-section">
        <div style="color: var(--tdo-secondary);" data-cy="scheduler-doctor-label">Doctor</div>
        <div style="width: 100%;" data-cy="scheduler-doctor-dropdown-container">
          <tdo-dropdown-v2 [isMultiSelect]="true" [isIncludeAll]="true" [isAutoSelectAll]="true"
                           [displayPredicate]="doctorPredicate" widthString="100%"
                           *ngIf="providerDocs" [datasource]="providerDocs" (closed)="onDocListClosed($event)"
                           (selectionChange)="onDocListChanged($event)"
                           data-cy="scheduler-doctor-dropdown"></tdo-dropdown-v2>
        </div>
      </div>
    </div>
    <div *ngIf="showWaitList || isReferralAppointment || isReschedule"
         style="height: 100%; overflow-y: auto; margin-right: 5px; width: 150px"
         data-cy="scheduler-additional-options-section">
      <div *ngIf="showWaitList" class="scheduler-view-options-list-item" data-cy="scheduler-waitlist-item">
        <div class="list-item-pill" (click)="onOpenWaitListComponent()" data-cy="scheduler-waitlist-button">
          <div style="flex: 1; padding-left: 5px; text-align: left;" data-cy="scheduler-waitlist-label">Wait List</div>
        </div>
      </div>
      <div *ngIf="isReschedule" data-cy="scheduler-reschedule-item">
        <div class="list-item-pill-warning" [matTooltip]="getRescheduleTooltipText()"
             matTooltipPosition="below" matTooltipClass="multiline-tooltip"
             data-cy="scheduler-reschedule-button">
          <div style="flex: 1; padding-left: 5px; text-align: left;" data-cy="scheduler-reschedule-label">Paste Reschedule</div>
        </div>
      </div>
      <div *ngIf="isReferralAppointment" class="scheduler-view-options-list-item" data-cy="scheduler-referral-item">
        <div class="list-item-pill" #tooltip2="matTooltip" [matTooltip]="getReferralTooltipText()"
             matTooltipPosition="below" matTooltipClass="multiline-tooltip"
             (contextmenu)="$event.preventDefault(); onRowContextMenu($event)"
             data-cy="scheduler-referral-button">
          <div style="flex: 1; padding-left: 5px; text-align: left;" data-cy="scheduler-referral-label">Referral</div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="viewType !== 'dayDetailView'" style="flex-basis: 20px; display: flex; margin-left: var(--margin-size);" data-cy="scheduler-location-tabs">
    <div (click)="onLocationTabSelected(loc)" *ngFor="let loc of selectedLocations" class="scheduler-tab-item"
         [ngClass]="{'scheduler-tab-item-selected': isSelectedLocationTab(loc)}"
         data-cy="scheduler-location-tab-item">{{loc.Name}}</div>
  </div>
  <div class="scheduler-content" *ngIf="viewType !== 'dayDetailView'" data-cy="scheduler-content-container">
    <div *ngIf="!currentLocation" class="missing-data-message" data-cy="scheduler-missing-location-message"> Please select a Location from the available list.</div>
    <div *ngIf="currentLocation && currentLocationOperatoryData.length==0" class="missing-data-message" data-cy="scheduler-missing-operatory-message"> Please select
      an Operatory from the available list.
    </div>
    <div *ngIf="viewType !== 'dayDetailView'" style="flex-basis: 5px; background-color: white;"></div>
    <div style="flex: 1; overflow: hidden; margin-top: 1px;" data-cy="scheduler-appointments-container">
      <app-scheduling style="width: 100%; height: 100%;"
                      *ngIf="viewType !== 'dayDetailView' && currentLocation && currentLocationOperatoryData.length>0"
                      #scheduling [tdoCurrentDate]="selectedDate" [operatoryDataModels]="currentLocationOperatoryData"
                      (appointmentDialogDataForWaitList)="receiveObject($event)" [viewType]="viewType"
                      data-cy="scheduler-appointments-grid"></app-scheduling>
    </div>
  </div>
  <div *ngIf="viewType === 'dayDetailView'"
       style="flex: 1; margin: 0 var(--margin-size) var(--margin-size) var(--margin-size);"
       data-cy="scheduler-day-detail-container">
    <app-day-detail-view #detailView [selectedDoctors]="selectedDocs" [selectedDate]="selectedDate"
                         style="display: flex; flex: 1; width: 100%; height: 100%; overflow-y: hidden;"
                         *ngIf="viewType === 'dayDetailView' && selectedDocs && selectedDocs.length > 0"
                         data-cy="scheduler-day-detail-view"></app-day-detail-view>
  </div>
</div>


